export enum ModelType {
  PRIME = 'prime',
  COMPANY = 'company',
}

export const MODEL_TYPE_LABELS: Record<ModelType, string> = {
  [ModelType.PRIME]: 'Prime',
  [ModelType.COMPANY]: 'Company',
};

export const MODEL_TYPE_OPTIONS = Object.values(ModelType).map(type => ({
  value: type,
  label: MODEL_TYPE_LABELS[type],
}));

export interface ModelSelection {
  type: ModelType;
  artifactId?: string; // For Prime model - selected root artifact
  artifactTreeId?: string; // For Company model - artifact tree (root container)
  businessModelId?: string; // For Company model - specific business model within the tree
}
